// AFC team logos
const afcTeamLogos = {
    "Denver Broncos":
      "https://upload.wikimedia.org/wikipedia/en/thumb/4/44/Denver_Broncos_logo.svg/1280px-Denver_Broncos_logo.svg.png",

    "New England Patriots":
      "https://upload.wikimedia.org/wikipedia/en/thumb/b/b9/New_England_Patriots_logo.svg/1280px-New_England_Patriots_logo.svg.png",

    "Jacksonville Jaguars":
      "https://upload.wikimedia.org/wikipedia/en/thumb/7/74/Jacksonville_Jaguars_logo.svg/1280px-Jacksonville_Jaguars_logo.svg.png",

    "Pittsburgh Steelers":
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Pittsburgh_Steelers_logo.svg/1280px-Pittsburgh_Steelers_logo.svg.png",

    "Houston Texans":
      "https://upload.wikimedia.org/wikipedia/en/thumb/2/28/Houston_Texans_logo.svg/1280px-Houston_Texans_logo.svg.png",

    "Buffalo Bills":
      "https://upload.wikimedia.org/wikipedia/en/thumb/7/77/Buffalo_Bills_logo.svg/1280px-Buffalo_Bills_logo.svg.png",

    "Los Angeles Chargers":
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Los_Angeles_Chargers_logo.svg/1280px-Los_Angeles_Chargers_logo.svg.png",

    "Indianapolis Colts":
      "https://upload.wikimedia.org/wikipedia/commons/0/00/Indianapolis_Colts_logo.svg",

    "Baltimore Ravens":
      "https://upload.wikimedia.org/wikipedia/en/1/16/Baltimore_Ravens_logo.svg",

    "Miami Dolphins":
      "https://upload.wikimedia.org/wikipedia/en/thumb/3/37/Miami_Dolphins_logo.svg/1280px-Miami_Dolphins_logo.svg.png",

    "Cincinnati Bengals":
      "https://sportslogohistory.com/wp-content/uploads/2021/04/cincinnati_bengals_2021-pres.png",

    "Kansas City Chiefs":
      "https://upload.wikimedia.org/wikipedia/en/thumb/e/e1/Kansas_City_Chiefs_logo.svg/1280px-Kansas_City_Chiefs_logo.svg.png",

    "Cleveland Browns":
      "https://upload.wikimedia.org/wikipedia/en/thumb/d/d9/Cleveland_Browns_logo.svg/1280px-Cleveland_Browns_logo.svg.png",

    "Las Vegas Raiders":
      "https://upload.wikimedia.org/wikipedia/en/thumb/4/48/Las_Vegas_Raiders_logo.svg/1280px-Las_Vegas_Raiders_logo.svg.png",

    "New York Jets":
      "https://upload.wikimedia.org/wikipedia/commons/6/69/New_York_Jets_2024.svg",

    "Tennessee Titans":
      "https://static.www.nfl.com/t_q-best/league/api/clubs/logos/TEN.png",
};

export default afcTeamLogos;